<template>
  <div class="d-flex flex-column ml-auto mt-auto" :class="{'mobile' : device === 'mobile'}">
    <template v-if="motorOption !== 'closed_frame'">
      <div class="supply text-center mb-2" :class="[device === 'mobile' ? 'mr-auto' : 'ml-auto']">
        <span style="font-size: 12px; font-style: italic;">{{ $t('powerpack.price.deliveryTime') }}</span>
        <img class="mb-1"
             :src="getImage('warning.svg')"
             :id="'supply' + motor.id"
             @mouseenter="hover = true"
             @mouseleave="hover = true"
             v-if="getDeliveryTime < 1"
        >
        <img class="mb-1 ml-2"
             :src="getImage('check-motor.svg')"
             :id="'supply' + motor.id"
             @mouseenter="hover = true"
             @mouseleave="hover = true"
             v-else
        >
        <b-tooltip :show.sync="hover" :target="'supply' + motor.id" placement="top" variant="info" boundary="window">
          <div v-if="getDeliveryTime < 1"
               v-html="$t('powerpack.price.deliveryInfo', { deliveryTime: getDeliveryTime })">
          </div>
          <div v-else-if="canShowModule(['mini_powerpack','and_pump'])">
            {{ $t('powerpack.price.deliveryInfo2days') }}
          </div>
          <div v-else-if="canShowModule(['workplace', 'open_frame', 'industrial'])">
            {{ $t('powerpack.price.deliveryInfo5days') }}
          </div>
          <div v-else>
            {{ $t('powerpack.price.deliveryInfo5days') }}
          </div>
        </b-tooltip>
      </div>
      <div class="total-price mb-1">
        <div class="d-flex flex-column justify-content-between price-container"
             :class="[device === 'mobile' ? 'align-items-start' : 'align-items-end']">
          <span class="title">{{ $t('powerpack.price.total') }}</span>
          <span class="price blue" v-text="price(total)"></span>
          <span class="sub-title btw d-inline">{{ price(total + btw) }} {{ $t('powerpack.price.vat') }}</span>
        </div>
      </div>
      <button
          class="add-btn"
          type="button"
          @click.stop="order"
          :class="{'disabled': !canCheckoutValidation}"
      >
        <img src="../../../assets/cart-icon.png">
        <span>{{ $t('powerpack.price.add') }}</span>
      </button>
      <small class="alert-danger text-alert error" v-if="checkoutValidationFailed">Voeg een klep toe.</small>
    </template>

    <template v-else>
      <div class="total-price mb-1">
        <div class="d-flex flex-column justify-content-between price-container"
             :class="[device === 'mobile' ? 'align-items-start' : 'align-items-end']">
          <span class="title">{{ $t('powerpack.price.from') }}</span>
          <span class="price blue" v-text="price(total)"></span>
          <span class="sub-title btw d-inline">{{ price(total + btw) }} {{ $t('powerpack.price.vat') }}</span>
        </div>
      </div>
      <button
          v-if="motorOption === 'closed_frame'"
          class="add-btn"
          type="button"
          @click="openQuoteModal"
      >
        <span>{{ $t('powerpack.price.quote') }}</span>
      </button>

      <PopupClosedFrameQuote v-if="showQuoteModal" @close="showQuoteModal = false" />
    </template>
  </div>
</template>
<script>
import {mapState, mapGetters} from 'vuex';
import getBuildMixin from "@/mixins/getBuildMixin";
import getDeliveryTimeMixin from "@/mixins/getDeliveryTimeMixin";
import addToCartMixin from "@/mixins/addToCartMixin";
import PopupClosedFrameQuote from "@/components/popup/PopupClosedFrameQuote";
import showModuleMixin from "@/mixins/showModuleMixin";
import googleAnalyticsMixin from '@/mixins/googleAnalyticsMixin';

export default {
  name: "Price",
  components: {PopupClosedFrameQuote},
  data() {
    return {
      hover: false,
      checkoutValidationFailed: false,
      showQuoteModal: false,
    }
  },
  mixins: [getBuildMixin, getDeliveryTimeMixin, addToCartMixin, showModuleMixin, googleAnalyticsMixin],
  computed: {
    ...mapState({
      btwValue: state => state.preference.BTW | 0,
    }),
    ...mapGetters({
      motorOption: 'build/getMotorOption',
      powerpackOptions: 'powerpackOptions/getPriceObject',
      openFrameOptions: 'openFrameOptions/getPriceObject',
      closedFrameOptions: 'closedFrameOptions/getPriceArray',
      allPowerpackOptions: 'powerpackOptions/getAll',
      allOpenFrameOptions: 'openFrameOptions/getAll',
      allClosedFrameOptions: 'closedFrameOptions/getAll',
      device: 'getDevice',
      isMagento: 'preference/isMagento',
    }),

    canCheckoutValidation() {
      if (this.motorOption === 'open_frame') {
        return this.valves.length >= 1;
      }
      return true;
    },

    subTotal() {
      let price = this.priceForType()
      price += this.motor ? this.motor.price : 0;
      price += this.pump ? this.pump.price : 0;
      price += this.tank ? this.tank.price : 0;
      price += this.dynamo ? this.dynamo.price : 0;
      price += this.tankerFloat ? this.tankerFloat.price : 0;
      price += this.waterAbsorbentTankAeration ? this.waterAbsorbentTankAeration.price : 0;
      price += this.circuit && this.motorOption !== 'industrial' ? this.circuit.price : 0;

      price += this.lid ? this.lid.price : 0;
      price += this.lanternPiece ? this.lanternPiece.price : 0;
      price += this.elasticCoupling ? this.elasticCoupling.price : 0;
      price += this.electricalBox ? this.electricalBox.price : 0;

      price += this.wheels ? this.wheels.price : 0;
      price += this.cooler ? this.cooler.price : 0;

      if (this.retourFilter) {
        const extraProduct = this.tank.extra_products.find(product => product.pivot.extra_product_id === this.retourFilter);

        if (extraProduct) {
          price += extraProduct.price;
        }
      }

      if (this.pump.extra_products) {
        this.pump.extra_products.forEach(product => {
          price += product.price;
        })
      }

      // Valves
      let buildValves = this.$store.getters["build/valves/getValves"];
      const valveIds = [];
      const additionalValveIds = [];
      buildValves.forEach(valve => {
        valveIds.push(valve.id);
        valve.additionalValves.forEach(additionalValveId => {
          additionalValveIds.push(additionalValveId);
        })
      });

      let a03 = null;
      if (this.motorOption !== 'workplace' && this.motorOption !== 'open_frame') {
        let a01 = this.allPowerpackOptions.find(option => option.type === 'A01');
        a03 = this.allPowerpackOptions.find(option => option.type === 'A03');

        if (valveIds.length) {
          price += a01.price;
        }
      }

      let allValves = Object.values(this.$store.getters["valves/getAll"]);
      valveIds.forEach((valveId) => {
        let valve = allValves.find((valve) => {
          return valve.id === +valveId;
        });
        if (valve && !valve.a10 && this.motorOption !== 'open_frame') {
          price += a03.price;
          price += valve.price;
        } else if (valve) {
          price += valve.price;
        }
      });

      let allAdditionalValves = Object.values(this.$store.getters["additionalValves/getAll"]);
      additionalValveIds.forEach((additionalValveId) => {
        let additionalValve = allAdditionalValves.find((additionalValve) => {
          return additionalValve.id === additionalValveId;
        });
        if (additionalValve) {
          price += additionalValve.price;
        }
      });

      //Additional options
      if ((this.motorOption === 'mini_powerpack') && this.powerpackOptions) {
        for (const option of this.powerpackOptions) {
          price += option.price || 0;
        }
      }

      if (this.motorOption === 'open_frame' && this.openFrameOptions) {
        for (const option of this.openFrameOptions) {
          price += option.price || 0;
        }
      }

      if (this.motorOption === 'closed_frame' && this.closedFrameOptions) {
        for (const option of this.closedFrameOptions) {
          price += option.price || 0;
        }
      }

      return price;
    },

    deliveryPrice() {
      // @todo ?
      return 0;
    },

    btw() {
      return this.subTotal * (this.btwValue / 100);
    },

    total() {
      return this.subTotal + this.deliveryPrice;
    },
  },
  methods: {
    price(val) {
      return (val / 100).toFixed(2);
    },
    priceForType() {
      switch (this.motorOption) {
        case 'mini_powerpack':
          return 7500;
        case 'open_frame':
        case 'industrial':
          return 10000;
        case 'and_pump':
          return 5000;
        case 'workplace':
          return 15000;
        case 'closed_frame':
          return 0;
        default:
          throw new Error('Invalid motor option');
      }
    },
    async order() {
      this.checkoutValidationFailed = false;
      if (this.canCheckoutValidation === false) {
        this.checkoutValidationFailed = true;
        return;
      }

      if (this.isMagento) {
        this.$emit('openModal');
        this.$store.dispatch('cart/addPowerpackMagentoOrder', 'powerpack')
            .then((order) => {
              this.$store.commit('cart/setCurrentOrder', order);
            })
            .catch((error) => {
              this.$store.commit('cart/setCurrentOrder', {error: error});
            })
      } else {
        const order = await this.$store.dispatch('cart/addOrder');

        this.pushDataLayer({
          interaction_type: this.gaData.interactionTypes.submitSystem,
          build_id: order.uid,
          value: this.price(order.price),
          step: this.gaData.undefined,
          field: this.gaData.undefined
        })
      }
    },
    openQuoteModal() {
      this.showQuoteModal = true;
    },
  }
}
</script>
<style scoped lang="scss">
.title {
  font-size: 14px;
  font-family: neue-haas-grotesk-display, sans-serif;
  font-weight: 700;
  display: block;
}

.sub-title {
  font-family: neue-haas-grotesk-text, sans-serif;
  font-size: 12px;
  font-weight: unset;

  &.btw {
    font-family: neue-haas-grotesk-text, sans-serif;
    font-weight: 700;
    font-size: 12px;
    font-style: italic;
  }
}

.price {
  font-size: 12px;
  font-family: neue-haas-grotesk-display, sans-serif;
  font-weight: 700;

  &.blue {
    font-size: 24px;
    color: #3DB0C7;
  }
}

.error {
  margin-top: 10px;
  font-size: 12px;
  border-radius: 50px;
  text-align: center;
}

.add-btn {
  display: flex;
  border-radius: 50px;
  background-color: #71BC03;
  text-transform: uppercase;
  color: white;
  border: none;
  height: 36px;
  align-content: center;
  justify-content: space-evenly;
  align-items: center;
  width: auto;
  min-width: 150px;
  margin-top: auto;
  font-size: 14px;
  font-family: neue-haas-grotesk-display, sans-serif;
  transition: all ease 0.3s;
  letter-spacing: 0.5px;
  cursor: pointer;
  white-space: nowrap;
  padding: 0 20px;

  &.disabled {
    background-color: #AFAFAF;

    &:hover {
      cursor: not-allowed;
      background-color: #A4AFB7;
    }
  }

  &:hover {
    background-color: darken(#71BC03, 10%);
  }

  &:focus, &:active {
    outline: none;
  }
}

.mobile {
  margin-top: 16px !important;

  .add-btn {
    width: 150px;
  }
}
</style>
